<script>
import appConfig from "@/app.config";
import moment from 'moment';
import { authEasyMethods, notificationMethods } from '@/state/helpers';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import List from "./list.vue";
import Insert from "./insert.vue";
import Edit from "./edit.vue";
import Swal from 'sweetalert2';
import AccountsPayable from '@/controller/AccountsPayable';

export default {
  page: {
    title: 'Contas a pagar',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout, PageHeader, Insert, List, Edit},
  data() {
    return {
      currentContaPagar:{},
      counter: 0,
      planoContas: [],
      professionals: [],
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Financeiro",
          href: "/",
          active: true,
        },
        {
          text: "Contas a Pagar",
          href: "/financeiro/contasPagar",
          active: true,
        }
      ],    
      banco: undefined,
      pagas: [],
      contasPagar: [],
      titleBody: 'Conta a pagar',
      editando: false,
      inserindo: false,
      pagamento:false,
      clientes:[],
      historicos:[],
      centtros:[],
      resultados:[],
      tiposPagamentos:[]
    }
  },
  created() {
    this.currentUser    = JSON.parse(localStorage.getItem('user')); // para saber qual o usuario atual;
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'));// para saber a emrpessa atual;
    this.AccountsPayable = new AccountsPayable();
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
    isHide() {
      return (!this.inserindo && !this.editando && !this.pagamento);
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...authEasyMethods,
    ...notificationMethods,
    makeToast(variant = null, message = 'Error generic') {
      this.counter++;
      this.$bvToast.toast(message, {
        title: `Notificação`,
        toaster: 'b-toaster-bottom-right',
        variant: variant,
        solid: true,
        appendToast: true
      });
    },
    changeHomeTitle(newTitle) {
      this.titleBody = newTitle;
    },
    onLoader() {
      if (document.getElementById("preloader").style.display === "none")
      {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
      }
    },
    offLoader() {
      if (document.getElementById("preloader").style.display === "block")
      {
        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      }
    },
    async getData() {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: 'Aguarde...',
        text: 'Estamos processando sua solicitação.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      try {
        const result = await this.AccountsPayable.getAccountsPayable(this.currentEmpresa.id);
        
        if (result.success) {
          this.contasPagar = result.data.contasPagar;
          this.planoContas = result.data.planoContas;
          this.professionals = result.data.professionals || [];
          setTimeout(() => {
            Swal.close();
          }, 2000);
        } else {
          this.contasPagar = [];
          this.planoContas = [];
          this.professionals = [];
          this.makeToast('danger', 'Erro ao carregar lista');
          Swal.close();
        }
      } catch (error) {
        Swal.close();
        this.makeToast('danger', 'Erro ao carregar dados');
      }
    },
    setContaPagar(value) {
      this.currentContaPagar = value;
    },
    insert() {
      this.inserindo = !this.inserindo;
    },
    edit(oldPago) {
      this.currentContaPagar = oldPago;
      // Adequar para o componente b-form-input type="month"
      this.currentContaPagar.competencia = moment(`${this.currentContaPagar.ano_competencia}-${this.currentContaPagar.mes_competencia}-01`, 'YYYY-MM-DD').format('YYYY-MM');
      this.editando = !this.editando;
    },
    async doPost(contaPagar) {
      // Exibe o SweetAlert com loader
      Swal.fire({
        title: 'Aguarde...',
        text: 'Estamos processando sua solicitação.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      contaPagar.empresa_id = this.currentEmpresa.id
      contaPagar.user_id = this.currentUser.id

      try {
        // Envia tudo em uma única chamada (FormData)
        const form = new FormData()
        Object.keys(contaPagar).forEach(k => {
          if (k === 'arquivos' || k === 'files') return
          if (contaPagar[k] !== undefined && contaPagar[k] !== null) {
            form.append(k, contaPagar[k])
          }
        })
        // arquivos
        const rawFiles = []
        if (contaPagar.files && contaPagar.files.length) {
          for (let i=0;i<contaPagar.files.length;i++) rawFiles.push(contaPagar.files[i])
        } else if (Array.isArray(contaPagar.arquivos)) {
          contaPagar.arquivos.forEach(it => { if (it && it.file instanceof File) rawFiles.push(it.file) })
        }
        // Anexe como 'files' (sem colchetes) para melhor compatibilidade com Laravel
        // Use array notation para compatibilidade com Laravel
        rawFiles.forEach(f => form.append('files[]', f))

        const result = await this.AccountsPayable.http.post(
          `/contas-a-pagar?empresa_id=${this.currentEmpresa.id}`,
          form
        )
        Swal.close()
        
        if (result.status === 200) {
          // Tenta obter o ID retornado pela API
          let newContaId = result.data?.id || result.data?.conta?.id || null

          // Caso não haja ID na resposta, tenta localizar pela combinação dos campos
          if (!newContaId) {
            const reload = await this.AccountsPayable.getAccountsPayable(this.currentEmpresa.id)
            if (reload.success) {
              const candidatos = (reload.data?.contasPagar || []).filter(cp => {
                const sameDoc   = (cp.numero_documento || '') === (contaPagar.numero_documento || '')
                const sameDesc  = (cp.descricao || '') === (contaPagar.descricao || '')
                const sameValor = String(cp.valor_pagar || cp.valor || '') === String(contaPagar.valor_pagar || '')
                const sameVenc  = (cp.vencimento || '') === (contaPagar.vencimento || '')
                return sameDoc && sameDesc && sameValor && sameVenc
              })
              if (candidatos.length > 0) {
                // escolhe o de maior id
                newContaId = candidatos.sort((a,b)=> (b.id||0)-(a.id||0))[0].id
              }
            }
          }

          // Envia múltiplos arquivos (se houver)
          const rawFiles = []
          // Preferência: files vindo do insert via input
          if (contaPagar.files && contaPagar.files.length) {
            for (let i=0;i<contaPagar.files.length;i++) rawFiles.push(contaPagar.files[i])
          } else if (Array.isArray(contaPagar.arquivos)) {
            contaPagar.arquivos.forEach(it => {
              if (it && it.file instanceof File) rawFiles.push(it.file)
            })
          }

          this.makeToast('success', 'Registro incluído')
          this.back()
          this.getData()
        } else {
          this.makeToast('danger', 'Erro ao incluir conta a pagar')
          if (result.data?.message) {
            this.makeToast('danger', result.data.message)
          }
        }
      } catch (error) {
        Swal.close()
        this.makeToast('danger', 'Erro ao incluir conta a pagar')
      }
    },
    async doPut(contaPagar) {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Atualizando dados',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })
      contaPagar.empresa_id = this.currentEmpresa.id
      contaPagar.user_id    = this.currentUser.id
      console.log(contaPagar)

      try {
        const result = await this.AccountsPayable.updateAccountPaid(contaPagar, this.currentEmpresa.id)
        Swal.close()
        
        if (result.success) {
          this.makeToast('success', 'Registro alterado')
          this.getData()
          this.editando = false
        } else {
          this.makeToast('danger', 'Erro ao alterar registro')

          if (result.message) {
            this.makeToast('danger', result.message)
          }
        }
      } catch (error) {
        console.log(error)
        Swal.close()
        this.makeToast('danger', 'Erro ao alterar registro')
      }
    },
    async doDelete(contaPagar) {
      // Verifica se a conta está paga
      if (contaPagar.status === 1) {
        await Swal.fire({
          title: 'Atenção!',
          text: 'Não é possível excluir uma conta que já foi paga (baixada).',
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendi',
          showCancelButton: false
        });
        return;
      }

      // Perguntar se tem certeza com SweetAlert2
      const result = await Swal.fire({
        title: 'Tem certeza?',
        text: 'Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) {
        return
      }

      Swal.fire({
        title: 'Aguarde...',
        text: 'Atualizando dados',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      try {
        const result = await this.AccountsPayable.deleteAccountPaid(contaPagar, this.currentEmpresa.id);
        Swal.close()

        if (result.success) {
          this.getData()
          this.makeToast('warning', 'Registro excluído')
        } else {
          this.makeToast('danger', 'Erro ao excluir registro')

          if (result.message) {
            this.makeToast('danger', result.message)
          }
        }
      } catch (error) {
        console.log(error)
        Swal.close()
        this.makeToast('danger', 'Erro ao excluir registro')
      }
    },
    back() {
      this.inserindo = false
      this.editando  = false
      this.pagamento = false
      this.titleBody = 'Conta a Pagar'
    },
    async pagarSelecionadas(contasIds) {
      if (!contasIds || contasIds.length === 0) {
        this.makeToast('warning', 'Nenhuma conta selecionada');
        return;
      }

      // Verifica se todos os itens selecionados estão pendentes
      const contasSelecionadas = this.contasPagar.filter(conta => contasIds.includes(conta.id));
      const contasPagas = contasSelecionadas.filter(conta => conta.status === 1);

      if (contasPagas.length > 0) {
        // Mostra alerta se há contas já pagas
        await Swal.fire({
          title: 'Atenção!',
          text: `Existem ${contasPagas.length} conta(s) já pagas entre as selecionadas. É necessário desmarcar os pagamentos já baixados antes de prosseguir.`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendi',
          showCancelButton: false
        });
        return;
      }

      // Confirma o pagamento em massa
      const result = await Swal.fire({
        title: 'Confirmar Pagamento',
        text: `Deseja realmente pagar ${contasIds.length} conta(s) selecionada(s)?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, Pagar!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        // Exibe loader durante o processo
        Swal.fire({
          title: 'Processando...',
          text: 'Realizando pagamento das contas selecionadas.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await this.AccountsPayable.payMultipleAccounts(
            contasIds, 
            this.currentEmpresa.id, 
            this.currentUser.id
          );

          Swal.close();

          if (response.success) {
            this.makeToast('success', `${contasIds.length} conta(s) paga(s) com sucesso!`);
            this.getData(); // Recarrega a lista
          } else {
            this.makeToast('danger', response.message || 'Erro ao pagar contas selecionadas');
          }
        } catch (error) {
          Swal.close();
          this.makeToast('danger', 'Erro ao processar pagamento das contas');
        }
      }
    },
    async excluirSelecionadas(contasIds) {
      if (!contasIds || contasIds.length === 0) {
        this.makeToast('warning', 'Nenhuma conta selecionada');
        return;
      }

      // Verifica se há contas pagas entre as selecionadas
      const contasSelecionadas = this.contasPagar.filter(conta => contasIds.includes(conta.id));
      const contasPagas = contasSelecionadas.filter(conta => conta.status === 1);

      if (contasPagas.length > 0) {
        // Mostra alerta se há contas pagas
        await Swal.fire({
          title: 'Atenção!',
          text: `Existem ${contasPagas.length} conta(s) pagas entre as selecionadas. Não é possível excluir contas que já foram pagas (baixadas).`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendi',
          showCancelButton: false
        });
        return;
      }

      // Confirma a exclusão em massa
      const result = await Swal.fire({
        title: 'Confirmar Exclusão',
        text: `Deseja realmente excluir ${contasIds.length} conta(s) selecionada(s)?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, Excluir!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        // Exibe loader durante o processo
        Swal.fire({
          title: 'Processando...',
          text: 'Excluindo contas selecionadas.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await this.AccountsPayable.excluirMultiplas(contasIds, this.currentEmpresa.id);
          
          Swal.close();
          
          if (response.success) {
            this.makeToast('success', `${contasIds.length} conta(s) excluída(s) com sucesso!`);
            this.getData(); // Recarrega a lista
          } else {
            this.makeToast('danger', response.message || 'Erro ao excluir contas selecionadas');
          }
        } catch (error) {
          Swal.close();
          this.makeToast('danger', 'Erro ao processar exclusão das contas');
        }
      }
    },
    async cancelarBaixa(contaPagar) {
      // Confirma o cancelamento da baixa
      const result = await Swal.fire({
        title: 'Confirmar Cancelamento',
        text: `Deseja realmente cancelar a baixa da conta ${contaPagar.numero_documento || contaPagar.id}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ffc107',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, Cancelar Baixa!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        // Exibe loader durante o processo
        Swal.fire({
          title: 'Processando...',
          text: 'Cancelando baixa da conta.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await this.AccountsPayable.cancelarBaixa(contaPagar, this.currentEmpresa.id);
          
          Swal.close();
          
          if (response.success) {
            this.makeToast('success', 'Baixa cancelada com sucesso!');
            this.getData(); // Recarrega a lista
          } else {
            this.makeToast('danger', response.message || 'Erro ao cancelar baixa');
          }
        } catch (error) {
          Swal.close();
          this.makeToast('danger', 'Erro ao cancelar baixa da conta');
        }
      }
    },
    async cancelarBaixasSelecionadas(contasIds) {
      if (!contasIds || contasIds.length === 0) {
        this.makeToast('warning', 'Nenhuma conta selecionada');
        return;
      }

      // Verifica se todos os itens selecionados estão pagos
      const contasSelecionadas = this.contasPagar.filter(conta => contasIds.includes(conta.id));
      const contasPendentes = contasSelecionadas.filter(conta => conta.status === 0);

      if (contasPendentes.length > 0) {
        // Mostra alerta se há contas pendentes
        await Swal.fire({
          title: 'Atenção!',
          text: `Existem ${contasPendentes.length} conta(s) pendentes entre as selecionadas. Apenas contas pagas podem ter suas baixas canceladas.`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Entendi',
          showCancelButton: false
        });
        return;
      }

      // Confirma o cancelamento das baixas em massa
      const result = await Swal.fire({
        title: 'Confirmar Cancelamento',
        text: `Deseja realmente cancelar a baixa de ${contasIds.length} conta(s) selecionada(s)?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ffc107',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, Cancelar Baixas!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        // Exibe loader durante o processo
        Swal.fire({
          title: 'Processando...',
          text: 'Cancelando baixas das contas selecionadas.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await this.AccountsPayable.cancelarBaixasMultiplas(contasIds, this.currentEmpresa.id);
          
          Swal.close();
          
          if (response.success) {
            this.makeToast('success', `${contasIds.length} baixa(s) cancelada(s) com sucesso!`);
            this.getData(); // Recarrega a lista
          } else {
            this.makeToast('danger', response.message || 'Erro ao cancelar baixas selecionadas');
          }
        } catch (error) {
          Swal.close();
          this.makeToast('danger', 'Erro ao processar cancelamento das baixas');
        }
      }
    },
    async baixarConta(contaPagar) {
      // Confirma o pagamento da conta
      const result = await Swal.fire({
        title: 'Confirmar Pagamento',
        text: `Deseja realmente baixar a conta ${contaPagar.numero_documento || contaPagar.id}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sim, Baixar!',
        cancelButtonText: 'Cancelar'
      });

      if (result.isConfirmed) {
        // Exibe loader durante o processo
        Swal.fire({
          title: 'Processando...',
          text: 'Baixando conta.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        try {
          const response = await this.AccountsPayable.baixarConta(contaPagar, this.currentEmpresa.id);
          
          Swal.close();
          
          if (response.success) {
            this.makeToast('success', 'Conta baixada com sucesso!');
            this.getData(); // Recarrega a lista
          } else {
            this.makeToast('danger', response.message || 'Erro ao baixar conta');
          }
        } catch (error) {
          Swal.close();
          this.makeToast('danger', 'Erro ao baixar conta');
        }
      }
    },
  },
}
</script>
<template>
<Layout>
  <PageHeader :title="titleBody" :items="items" />
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-6"></div>
            <div class="col-sm-12 col-md-6 text-md-right">
              <button @click="insert()" v-if="isHide" type="button" class="btn btn-success">+ Incluir Despesa</button>
              <button @click="back()" v-if="!isHide" class="btn btn-secondary">Voltar</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div v-if="!isHide" class="card-body">
          <Edit v-if="editando"
            @newTitle="changeHomeTitle"
            @doPut="doPut"
            :empresa="currentEmpresa"
            :oldContaPagar="currentContaPagar"
            :planoContas="planoContas"
            :professionals="professionals"
          />
          <h4 v-if="inserindo" class="card-title">Incluir Despesa</h4>
          <Insert v-if="inserindo"
            @newTitle="changeHomeTitle"
            @back="back"
            @doPost="doPost"
            :planoContas="planoContas"
            :professionals="professionals"
          />
        </div>
        <List
          v-if="isHide"
          :currentEmpresa="currentEmpresa"
          :contasPagar="contasPagar"
          :professionals="professionals"
          :currentUser="currentUser"
          :hide="isHide"
          @edit="edit"
          @newTitle="changeHomeTitle"
          @setContaPagar="setContaPagar"
          @doDelete="doDelete"
          @cancelarBaixa="cancelarBaixa"
          @baixarConta="baixarConta"
          @cancelarBaixasSelecionadas="cancelarBaixasSelecionadas"
          @pagarSelecionadas="pagarSelecionadas"
          @excluirSelecionadas="excluirSelecionadas"
          @reloadData="getData"
        />
      </div>
    </div>
  </div>
</Layout>
</template>
